module.exports = __webpack_public_path__ + "ee2f044f439e31b6cafe43a3860a4715.png";